<!-- 城市地图车辆分布数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
              "parkCodeList": [
                "PS0AF53Q"
              ],
              "inventoryStartTime": "20230727152900",
              "inventoryEndTime": "20231127152900",
              "pageNum":2,
              "pageSize": 5
            },
            responseCode: {
                    "data": {},
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 获取盘点记录",
                t_url: this.commonUrls.test+"getInventoryRecord",
                p_url: this.commonUrls.prod+"getInventoryRecord",
                precondition: "无",
                fitSystem: "智汇云车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'JSONArray', info4: "车场编码List" },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号' },
                        { info1: 'inventoryStartTime', info2: '是', info3: 'String', info4: '盘点开始时间' },
                        { info1: 'inventoryEndTime', info2: '是', info3: 'String', info4: '盘点结束时间' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始，默认1' },
                        { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多1000条，默认10' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'parkCode', info2: '是', info3: 'String', info4: "车场编码" },
                          { info1: 'parkName', info2: '是', info3: 'String', info4: "车场名称" },
                          { info1: 'parkingCode', info2: '是', info3: 'String', info4: "停车流水号" },
                          { info1: 'carCode', info2: '是', info3: 'String', info4: "车牌号码" },
                          { info1: 'enterCarImageUrl', info2: '否', info3: 'String', info4: "进场车辆图片" },
                          { info1: 'enterPlateImageUrl', info2: '否', info3: 'String', info4: "进场车牌图片" },
                          { info1: 'enterPlateColor', info2: '否', info3: 'Integer', info4: "进场车牌颜色" },
                          { info1: 'enterTime', info2: '否', info3: 'String', info4: "进场时间" },
                          { info1: 'enterChannelId', info2: '否', info3: 'String', info4: "进场通道id" },
                          { info1: 'enterVipType', info2: '否', info3: 'Integer', info4: "身份类型" },
                          { info1: 'enterVipTypeStr', info2: '否', info3: 'String', info4: "身份类型描述" },
                          { info1: 'inventoryTime', info2: '否', info3: 'String', info4: "盘点时间" },
                          { info1: 'inventoryOrigin', info2: '否', info3: 'Integer', info4: "盘点来源" },
                          { info1: 'inventoryOperator', info2: '否', info3: 'String', info4: "盘点操作人" },
                          { info1: 'inventoryOriginStr', info2: '否', info3: 'String', info4: "盘点来源描述" },
                          { info1: 'enterChannelName', info2: '否', info3: 'String', info4: "进场通道名称" },
                          { info1: 'reason', info2: '否', info3: 'String', info4: "原因" },
                          { info1: 'remark', info2: '否', info3: 'String', info4: "备注" },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/carSearch/getInventoryRecord.vue